import { SecureRoute } from 'components/shared/secure_route';
import { ViewMounter } from 'components/view_mounter';
import React from 'react';
import { Panel, PanelPresets, UserPermissionsIds } from 'utility/enumerations';

function ToolsContainer() {
  return (
    <div>
      <SecureRoute
        path="/tools/decease-user-management"
        pathPermissionId={UserPermissionsIds.AccessDeceasedUserManagement}
        render={(props) => ViewMounter(props, [{
          viewPath: 'admin/tools/deceased_user_management/deceased_user_search',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'admin/tools/deceased_user_management/deceased_user_grid',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/tools/duplicate-user-management"
        pathPermissionId={UserPermissionsIds.AccessDuplicatePatientsOrCaregivers}
        render={(props) => ViewMounter(props, {
          viewPath: 'admin/tools/duplicate_user_management/duplicate_user_search',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        })}
      />
      <SecureRoute
        path="/tools/duplicate-user-management-results"
        pathPermissionId={UserPermissionsIds.AccessDuplicatePatientsOrCaregivers}
        render={(props) => ViewMounter(props, [{
          viewPath: 'admin/tools/duplicate_user_management/duplicate_user_search',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'admin/tools/duplicate_user_management/duplicate_user_grid',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/tools/system-information"
        pathPermissionId={UserPermissionsIds.AccessSystemInformation}
        render={(props) => ViewMounter(props, {
          viewPath: 'admin/tools/system_information/system_information',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        })}
      />
    </div>
  );
}

export default ToolsContainer;
